const inr = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  maximumFractionDigits: 0,
});
const inr2 = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  maximumFractionDigits: 2,
});
const numFmt = new Intl.NumberFormat("en-IN");

export function fmtCurrency(v, decimals = false) {
  if (v == null || Number.isNaN(v)) return "—";
  return (decimals ? inr2 : inr).format(v);
}

export function fmtNumber(v) {
  if (v == null || Number.isNaN(v)) return "—";
  return numFmt.format(v);
}

export function fmtDecimal(v, d = 2) {
  if (v == null || Number.isNaN(v)) return "—";
  return Number(v).toLocaleString("en-IN", { minimumFractionDigits: d, maximumFractionDigits: d });
}

export function fmtLakh(v) {
  if (v == null || Number.isNaN(v)) return "—";
  return (v / 100000).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function fmtDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso.length <= 10 ? iso + "T00:00:00" : iso);
  return d.toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" });
}

export function fmtDateShort(iso) {
  if (!iso) return "—";
  const d = new Date(iso.length <= 10 ? iso + "T00:00:00" : iso);
  return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

export const PERIOD_LABELS = {
  today: "Today",
  yesterday: "Yesterday",
  this_month: "This Month",
  previous_month: "Previous Month",
  custom: "Custom Range",
};

export function hasPerm(user, perm) {
  return !!user && Array.isArray(user.permissions) && user.permissions.includes(perm);
}

export function scopeActive(scope) {
  return scope === "all" || (Array.isArray(scope) && scope.length > 0);
}

export const PERMISSION_LABELS = {
  view_overall_dashboard: "View Overall Dashboard",
  view_floor_dashboard: "View Floor Dashboard",
  view_category_dashboard: "View Category Dashboard",
  view_salesman_dashboard: "View Salesman Dashboard",
  view_sales_amount: "View Sales Amount",
  view_abv: "View ABV",
  view_abq: "View ABQ",
  view_monthly_data: "View Monthly Data",
  view_trends: "Trend Charts",
  view_store_metrics: "View Store ABV / ABQ",
  view_floor_target: "View Floor Target Achievement",
  view_incentive: "View Incentive Competition",
  upload_data: "Upload Data",
  replace_data: "Replace Existing Data",
  view_upload_history: "View Upload History",
  manage_users: "Manage Users",
  manage_templates: "Manage Templates",
  manage_staff: "Manage Staff",
  manage_incentive_settings: "Manage Incentive Settings",
  manage_floor_targets: "Manage Floor Targets",
  manage_core_floor: "Manage Core Floor",
  view_diagnostic_data: "View Diagnostic Data",
  export_dashboard: "Export Dashboard",
};
